import { getLocalStorageKey, removeDeprecatedStorageData } from '../utils/storageUtils';

type State = {
  timezoneOffset: number;
};

type Listener = () => void;

class GlobalStore {
  private state: State = {
    timezoneOffset: 0,
  };

  private listeners = new Set<Listener>();

  getState = (): State => this.state;

  setTimezoneOffset = (timezoneOffset?: number): void => {
    if (timezoneOffset !== undefined) {
      this.state.timezoneOffset = timezoneOffset;
      const lastTimezoneOffset = localStorage.getItem(getLocalStorageKey('timezoneOffset'));
      if (!!lastTimezoneOffset && Number(lastTimezoneOffset) !== timezoneOffset) {
        removeDeprecatedStorageData();
      }
      localStorage.setItem(getLocalStorageKey('timezoneOffset'), timezoneOffset.toString());
    }
    this.emitChange();
  };

  subscribe = (listener: Listener): (() => void) => {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  };

  private emitChange = (): void => {
    this.listeners.forEach((listener) => listener());
  };
}

const globalStore = new GlobalStore();
export default globalStore;
